<template>
  <ul class="job-types-list" v-if="jobTypes.length">
    <li v-for="{ type, component } in jobTypes" :key="type">
      <component :is="component" :id="`${type}-${uid}`" />
      <b-tooltip :target="`${type}-${uid}`" triggers="hover">
        {{ $t(`job.types.${type}`) }}
      </b-tooltip>
    </li>
  </ul>
</template>

<script>
import {
  BIconLaptop,
  BIconCalendar,
  BIconCheckSquare,
  BIconWrench,
  BIconCart,
  BIconTools,
  BIconExclamationTriangle,
  BIconSpeedometer2,
  BIconFileEarmarkText,
  BIconPower,
  BIconPenFill,
  BIconBootstrapReboot,
  BTooltip,
} from 'bootstrap-vue';

const ICON_MAP = {
  is_remote: BIconLaptop,
  async_appointment: BIconCalendar,
  is_precheck: BIconCheckSquare,
  is_installation: BIconWrench,
  is_hardware_sale: BIconCart,
  is_maintenance: BIconTools,
  is_defect_elimination: BIconExclamationTriangle,
  is_meter_application: BIconSpeedometer2,
  is_planning: BIconFileEarmarkText,
  is_activation: BIconPower,
  is_customer_sign_required: BIconPenFill,
  is_reclamation: BIconBootstrapReboot,
};

export default {
  components: {
    BIconLaptop,
    BIconCalendar,
    BIconCheckSquare,
    BIconWrench,
    BIconCart,
    BIconTools,
    BIconExclamationTriangle,
    BIconSpeedometer2,
    BIconFileEarmarkText,
    BIconPower,
    BIconPenFill,
    BIconBootstrapReboot,
    BTooltip,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      uid:
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15),
    };
  },
  computed: {
    jobTypes() {
      return Object.keys(ICON_MAP)
        .filter((key) => this.item[key])
        .map((key) => ({
          type: key,
          component: ICON_MAP[key],
        }));
    },
  },
};
</script>

<style scoped>
.job-types-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  list-style-type: none;
  margin: 8px 0 0 0;
  padding: 0;
  font-size: 18px;
}
</style>
